
<div class="row tvs-bg-white py-5">
  <div class="col-12 mt-20 text-center pb-5 mb-5">
    <h1 class="tvs-text-orange mt-20 mb-5">404 - NO ENCONTRADO</h1>
    <h3 class="tvs-text-orange my-5">LA PÁGINA QUE BUSCAS NO EXISTE</h3>
    <a class="btn btn-primary btn-yellow tvs-btn my-5" href="javascript:history.back()">Regresar</a>
  </div>
</div>
